import { PageTransitions } from '~/client/components'
import { TermsAndConditionsWrapper } from '~/client/TermsAndConditions/TermsAndConditions'

const Terms = () => (
  <PageTransitions>
    <div className='container'>
      <TermsAndConditionsWrapper />
    </div>
  </PageTransitions>
)

export default Terms
